import React, { useContext } from 'react';
import HamQuest from '../api/HamQuestGiver';
import Button from '../forms/Button';
import Row from '../layout/Row';
import Form from '../forms/Form';
import Select from '../forms/Select';
import { HSOptions } from '../../constants/HSOptions';
import { QuestRoute } from '../api/QuestRoutes';
import Input from '../forms/Input';
import Checkbox from '../forms/Checkbox';
import { addSuffix, formatCurrency, generateId, inputDate, shortHandDate } from '../utility/functions';
import { addCardToAccount } from '../PaymentForm';
import Col from '../layout/Col';
import { UserContexts } from '../stateProvider/UsersContext';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import ModalFactory from '../Modal';
import { accountTypes } from '../pages/user';

export const getBD = () => {
  const currentDate = new Date();
  let dayOfMonth = currentDate.getDate();
  if (dayOfMonth > 28) dayOfMonth = 28;
  return dayOfMonth;
};

export const getBSD = (billingDay, billingStartDate) => {
  const currentDay = new Date();
  const BSD = new Date(billingStartDate ?? currentDay.setMonth(currentDay.getMonth() + 1));
  BSD.setDate(billingDay ?? getBD());

  if (BSD < currentDay) {
    BSD.setFullYear(currentDay.getFullYear());
    BSD.setMonth(currentDay.getMonth());
    if (currentDay.getDate() > billingDay) {
      BSD.setMonth(BSD.getMonth() + 1);
    }
  }

  return BSD;
};

const isValidDate = (dateString) => {
  // Check format YYYY-MM-DD
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) return false;
  // Check if date is valid
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

export const BillingStartDate = ({ values, setValue, editing, isSignup, ...props }) => {
  const isBillingDateValid =
    values.billingStartDate !== undefined &&
    values.billingStartDate !== null &&
    isValidDate(values.billingStartDate);

  const getMinMonth = () => {
    let min = 1;
    const BSDYear = parseInt(values.billingStartDate.split('-')[0]);
    const currentYear = new Date().getFullYear();
    const BD = values.billingDay;
    const today = new Date().getDate();
    if (BSDYear === currentYear) {
      min = new Date().getMonth() + (today < BD ? 0 : 1);
    }
    return min;
  };

  return (
    <>
      {isBillingDateValid ? (
        <Input
          label={'Next Billing Date'}
          name={'billingStartDate'}
          type="date"
          required
          readOnly
        />
      ) : (
        <Input
          label={'Next Billing Date'}
          type="text"
          value={''}
          required
          readOnly
          disabled
        />
      )}

      {!editing && (
        <Row>
          <Input
            label={'Day'}
            value={addSuffix(values.billingDay)}
            // type='number'
            standalone
            disabled
            style={{ width: '6em' }}
          />
          <Input
            label={'Month'}
            value={parseInt(values.billingStartDate.split('-')[1])}
            type="number"
            onChange={e => {
              const val = values.billingStartDate.split('-');
              val[1] = !e.target.value ? '' : e.target.value.toString().padStart(2, '0');
              setValue('billingStartDate', val.join('-'));
            }}
            min={isBillingDateValid ? getMinMonth() : 1}
            max={12}
            step={1}
            required
            standalone
            style={{ width: '6em' }}
          />
          <Input
            label={'Year'}
            value={values.billingStartDate.split('-')[0]}
            onChange={e => {
              const val = values.billingStartDate.split('-');
              val[0] = e.target.value;
              setValue('billingStartDate', val.join('-'));
            }}
            min={new Date().getFullYear()}
            step={1}
            type="number"
            standalone
            required
            style={{ width: '6em' }}
          />
        </Row>
      )}
    </>
  );
};

const reactivatedFamilyMember = (washClubList, lastModalModel) => {
  const childListId = generateId();

  const ChildForm = ({ ...props }) => {
    const context = useContext(UserContexts);
    const { user, washClub, setUser } = context || props.context;
    const [loading, setLoading] = React.useState(false);

    user.children.forEach(e => {
      e.hasAddPrice = e.hasAddPrice !== undefined ? e.hasAddPrice : e.billingAmount > 0;
    });
    const Total = user.children.reduce((acc, e) => {
      if (e.clubStatus === 'Active') {
        return acc + (e.billingAmount ? e.billingAmount : 0);
      }
      return acc;
    }, washClub.billingAmount);

    return (
      <Col>
        <table style={{ padding: '20px' }}>
          <tbody>
            <tr>
              <td>Reactivate?</td>
              <td>{user.fullName}</td>
              <td>
                <Select
                  options={washClubList}
                  otherLabel={{ val: 'productName' }}
                  value={washClub.productId}
                  disabled
                  nullable
                  required
                  standalone
                  readOnly
                />
              </td>
              <td style={{ width: '200px' }}>
                <Select
                  options={washClubList}
                  otherLabel={{ val: 'monthlyPrice', currency: true }}
                  value={washClub.productId}
                  disabled
                  readOnly
                  standalone
                  nullable
                />
              </td>
            </tr>
            {user.children.map((e, i) => {
              return (
                <tr key={i}>
                  <td>
                    <Checkbox
                      onChange={() => setReactivate(e.userId, setUser)}
                      checked={e.clubStatus === 'Active'}
                      standalone
                    />
                  </td>
                  <td>{e.fullName}</td>
                  <td>
                    <Select
                      options={washClubList}
                      defaultValue={e.awardProductId}
                      otherLabel={{ val: 'productName' }}
                      //disabled
                      nullable
                      standalone
                      callback={c => setChildClub(e.userId, setUser, c, washClubList)}
                    />
                  </td>
                  <td style={{ width: '200px' }}>
                    <Select
                      options={washClubList}
                      value={e.clubStatus === 'Active' ? e.awardProductId : 0}
                      otherLabel={{ val: e.hasAddPrice ? 'additionalCarPrice' : 'monthlyPrice', currency: true }}
                      disabled
                      standalone
                      nullable
                    />
                  </td>
                </tr>
              );
            })}
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>{formatCurrency(Total)}</td>
            </tr>
          </tbody>
        </table>
        <Button
          onClick={() => {
            submitWithChildrenForm(user, lastModalModel, setUser, childListId, context, setLoading);
            setLoading(true);
          }}
          disabled={loading}
        >
          Submit
          {loading && <Loading style={{ height: '50%', width: '2.5em' }} />}
        </Button>
      </Col>
    );
  };

  ModalFactory.show({
    id: childListId,
    title: 'Child Re-Signup',
    body: <ChildForm />,
  });
};

const setReactivate = (id, setUser) => {
  setUser(prevUser => ({
    ...prevUser,
    children: prevUser.children.map(child =>
      child.userId === id
        ? { ...child, clubStatus: child.clubStatus === 'Active' ? 'Inactive' : 'Active' }
        : child
    ),
  }));
};

const setChildClub = (id, setUser, clubId, washClubList) => {
  let addCarPrice = 0;
  let hasAddPrice = false;
  washClubList.forEach(club => {
    if (club.value === parseInt(clubId)) {
      hasAddPrice = club.additionalCarPrice > 0;
      addCarPrice = hasAddPrice ? club.additionalCarPrice : club.monthlyPrice;
    }
  });
  setUser(prevUser => ({
    ...prevUser,
    children: prevUser.children.map(child =>
      child.userId === id
        ? { ...child, awardProductId: parseInt(clubId), billingAmount: addCarPrice, hasAddPrice: hasAddPrice }
        : child
    ),
  }));
};

const updateWashClub = (clubId, setWC, washClubList) => {
  let Price = 0;
  washClubList.forEach(club => {
    if (club.value === parseInt(clubId)) {
      Price = club.monthlyPrice;
    }
  });
  setWC(prev => ({ ...prev, productId: parseInt(clubId), billingAmount: Price }));
};

const submitWithChildrenForm = (user, modalData, setUser, mId, context, setLoading) => {
  const childArray = [];
  user.children.forEach(child => {
    const childObj = {
      UserID: child.userId,
      Active: child.clubStatus === 'Active',
      ProductID: child.awardProductId,
    };
    childArray.push(childObj);
  });

  const postData = Object.assign({}, modalData, { children: childArray });

  HamQuest.post(QuestRoute.user.washClubSignupWithChild(user.userId), postData)
    .then(() => {
      setLoading(false);
      setUser(prev => ({
        ...prev,
        children: prev.children.map(child =>
          child.userId === user.userId ? { ...child, clubStatus: 'Active' } : child
        ),
      }));
      ModalFactory.close(mId);
      ModalFactory.show({
        title: 'Success!',
        body: `The user has been reactivated successfully.`,
        closeAfter: true,
        type: 'success',
      });
      context.refreshUser();
      context.refreshWC();
    })
    .catch(ex => {
      setLoading(false);
      ModalFactory.catch(ex);
    });
};

const getWashClubList = async set => {
  await HamQuest.get(QuestRoute.washClubs.clubs)
    .then(res => {
      res.forEach(e => {
        e.value = e.productId;
      });
      set(res);
    })
    .catch(ModalFactory.catch);
};

const WCSignUp = ({ child, isQuickSignup, ...props }) => {
    const context = useContext(UserContexts);
    const navigate = useNavigate();
    const { user, washClub, setWC, CC, refreshCC, refreshWC, washClubList, setWashClubList} = context || props.context

    if(washClubList.length === 0) {
        getWashClubList(setWashClubList);
        return <Loading />;
    }

    if (!user) {
        return <Loading />;
    }

    const showButton = (washClub.status === 'Inactive' || washClub.status === 'CreditHold' || washClub.status === 'BillingHold' || !washClub.status);
    const currentDate = new Date();

    if (!washClub.billingDay) {
        washClub.billingDay = getBD();
    }

    const OpenUser = (id) => {
        navigate('/user/' + id, { replace: true });
    }

    const activateAccount = () => {
        const lastBilling = new Date(washClub.lastBillingDate);

        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Reactivation`,
                body: (
                    <Col>
                        <span>Reactivate {user.fullName}'s Wash Club?</span>
                        <span>Their last charge was <b>{shortHandDate(lastBilling)}</b>.</span>
                    </Col>
                ),
            },
            promise: {
                title: 'Reactivating Wash Club',
                body: `Reactivating, please wait.`,
                callback: () => HamQuest.get(QuestRoute.user.washClubReactivation(user.userId))
            },
            confirmed: {
                title: 'Success',
                body: `${user.fullName}'s successfully reactivated.`,
                type: 'success'
            },
            finally: () => refreshWC()
        })
    }

    const resignUpForm = async () => {
        ModalFactory.closeAll();

        if (child && child.warning) {
            const continueSignup = await ModalFactory.confirmation({
                title: 'User is Already subscribed',
                type: 'warning',
                closeAfter: true,
                body: <div>This User's Billing day (<b>{addSuffix(child.billingDay)}</b>) is different from parent account. Adding this user to the family plan will affect the billing dates.<br />The new billing day will be on the <b>{addSuffix(washClub.billingDay)}</b>.<br />Are you sure you wish to continue?</div>
            })

            if (!continueSignup) return;
        }
        const lastBilling = new Date(washClub.lastBillingDate);

        if (!child) {
            if (!CC.onFile || washClub.status === 'CreditHold') {
                const res = !CC.onFile ? true : await ModalFactory.confirmation({
                    title: 'Add a Card?',
                    body: 'Would you like to add a new Credit Card to this account?',
                    closeAfter: true
                })

                if (res)
                    await addCardToAccount(user.userId)
                        .then(() => refreshCC())
                        .catch(ModalFactory.catch);
            }

            if (lastBilling >= new Date().setMonth(currentDate.getMonth() - 1)) {
                activateAccount();
                return;
            }
        }

        const statusOptions = HSOptions.washClub.status
            .filter(e => e.value === 'Active' || e.value === 'EndBillingPending')
            .map(e => ({
                ...e,
                disabled: false,
            }))

        const PAYG = [];
        const id = generateId();
        ModalFactory.show({
            id,
            title: child ? `Add ${child.fullName} to Plan` : washClub.status ? 'Re-Sign Up' : 'Signup',
            body: () => {
                return (
                    <Form
                        inputs={{
                            status: '',
                            productId: washClub.productId ?? '',
                            billingDay: getBD(),
                            billToday: true,
                            billingStartDate: inputDate(getBSD(getBD())),
                            parentAccountId: child ? user.userId : null,
                            isQuickSignup: isQuickSignup,
                        }}
                        onSubmit={async e => {
                            if (user.accountType === accountTypes.parent && !child) {
                                ModalFactory.close(id);
                                reactivatedFamilyMember(washClubList, e, OpenUser);
                                return;
                            }
                            
                            if (!e.billToday && !child) {
                                const nbd = e.billingStartDate.split('-');
                                const res = await ModalFactory.confirmation({
                                    title: 'Hold on!',
                                    body: `The customer won't be billed until their next scheduled billing date (${nbd[1]}/${nbd[2]}/${nbd[0]}), and their billing day will stay the same (${addSuffix(washClub.billingDay)}). Are you sure you wish to continue?`,
                                    closeAfter: true,
                                    type: 'warning'
                                })
                                if (!res) return;
                            }

                            let prorate = {};
                            if (e.billToday && child) {
                                prorate = await HamQuest.getQuery(QuestRoute.user.washClubProrate(user.userId), { childId: child.userId, productId: e.productId }).catch(ModalFactory.catch)
                                if (prorate.isProrated) {
                                    const res = await ModalFactory.confirmation({
                                        title: 'Prorated',
                                        body: `Complete prorated family plan signup? ${user.fullName} will be charged a prorated amount of ${formatCurrency(prorate.amount)}`,
                                        closeAfter: true
                                    })
                                    if (!res) return;
                                }
                            }

                            return (
                                HamQuest.post(QuestRoute.user.washClubSignup(child?.userId || user.userId), { ...e })
                                    .then(() => refreshWC())
                                    .then(res => {
                                        ModalFactory.update({
                                            id,
                                            title: 'Success!',
                                            body: child && e.billToday ? `${child.fullName} has been added to ${user.fullName}'s plan. Card was successfully charged ${formatCurrency(prorate.amount)}.` 
                                                : `${child ? child.fullName : user.fullName} signed up successfully.${e.billToday ? ' Card was successfully charged.'    
                                                : ''}`,
                                            buttons: [
                                                <Button
                                                    label={`To ${child ? child.firstName : user.firstName}'s Account`}
                                                    onClick={() => OpenUser(child ? child.customerId : user.customerId)}
                                                />
                                            ],
                                        })
                                    })
                                    .catch(ModalFactory.catch)
                            )
                        }}
                    >
                        {({ values, setValue }) => {
                            return (
                                <>
                                    <Select
                                        label='Status'
                                        name='status'
                                        options={statusOptions}
                                        required
                                    />
                                    <Select
                                        label='Wash Club'
                                        name='productId'
                                        getOptions={QuestRoute.washClubs.clubs}
                                        buildOptions={(e) => {
                                            if (e.type === 'DailyPass') {
                                                if (user.accountType !== accountTypes.standard) {
                                                    e.disabled = true;
                                                }
                                                PAYG.push(e.productId.toString())
                                            }
                                            e.label = e.productName;
                                            e.value = e.productId;
                                        }}
                                        callback={e => {updateWashClub(e, setWC, washClubList)}}
                                        nullable
                                        required
                                    />
                                    <Select
                                        label={child ? 'Additional Car Price' : 'Package Price'}
                                        getOptions={QuestRoute.washClubs.clubs + (!child ? HamQuest.queryString({ customer: user.customerId }) : '')}
                                        buildOptions={(e) => {
                                            e.label = child && e.additionalCarPrice ? formatCurrency(e.additionalCarPrice) :
                                                "Signup: " + formatCurrency(e.signupPrice) + " Monthly: " + formatCurrency(e.monthlyPrice);
                                            e.value = e.productId;
                                        }}
                                        value={values.productId}
                                        disabled
                                        readOnly
                                        standalone
                                        nullable
                                    />

                                    <Checkbox
                                        label='Charge Customer today?'
                                        name='billToday'
                                        callback={e => {
                                            if (child) return;
                                            const day = e ? getBD() : washClub.billingDay
                                            setValue('billingDay', day)

                                            const val = values.billingStartDate.split('-');
                                            val[2] = day.toString().padStart(2, '0');
                                            setValue('billingStartDate', val.join('-'))
                                        }}
                                    />

                                    {!child ? (
                                        <>
                                            {!PAYG.includes(values.productId) && (
                                                <>
                                                    <Input
                                                        label='Billing Day'
                                                        name='billingDay'
                                                        disabled
                                                        required
                                                    />
                                                    <BillingStartDate values={values} setValue={setValue} isSignup={true} />
                                                </>
                                            )}
                                        </>
                                    ) : null}

                                </>
                            )
                        }}
                    </Form>
                )
            }
        })
    }

    if (child) return <Button onClick={resignUpForm}>{child.awardName ? 'In a Wash Club' : 'Add To Plan'}</Button>;

    if (!showButton) return null;

    return <Button onClick={resignUpForm}>Wash Club {washClub.status ? 'Re-' : ''}Sign Up</Button>;
}

export default WCSignUp;
